/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SegmentStatistic } from './SegmentStatistic';
import {
    SegmentStatisticFromJSON,
    SegmentStatisticFromJSONTyped,
    SegmentStatisticToJSON,
    SegmentStatisticToJSONTyped,
} from './SegmentStatistic';
import type { Segment } from './Segment';
import {
    SegmentFromJSON,
    SegmentFromJSONTyped,
    SegmentToJSON,
    SegmentToJSONTyped,
} from './Segment';

/**
 * 
 * @export
 * @interface SegmentResponse
 */
export interface SegmentResponse {
    /**
     * 
     * @type {Segment}
     * @memberof SegmentResponse
     */
    segment: Segment;
    /**
     * 
     * @type {number}
     * @memberof SegmentResponse
     */
    accountCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentResponse
     */
    hasPermission: boolean;
    /**
     * 
     * @type {Array<SegmentStatistic>}
     * @memberof SegmentResponse
     */
    statsByStatusAndPeriod: Array<SegmentStatistic>;
}

/**
 * Check if a given object implements the SegmentResponse interface.
 */
export function instanceOfSegmentResponse(value: object): value is SegmentResponse {
    if (!('segment' in value) || value['segment'] === undefined) return false;
    if (!('accountCount' in value) || value['accountCount'] === undefined) return false;
    if (!('hasPermission' in value) || value['hasPermission'] === undefined) return false;
    if (!('statsByStatusAndPeriod' in value) || value['statsByStatusAndPeriod'] === undefined) return false;
    return true;
}

export function SegmentResponseFromJSON(json: any): SegmentResponse {
    return SegmentResponseFromJSONTyped(json, false);
}

export function SegmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'segment': SegmentFromJSON(json['segment']),
        'accountCount': json['accountCount'],
        'hasPermission': json['hasPermission'],
        'statsByStatusAndPeriod': ((json['statsByStatusAndPeriod'] as Array<any>).map(SegmentStatisticFromJSON)),
    };
}

export function SegmentResponseToJSON(json: any): SegmentResponse {
    return SegmentResponseToJSONTyped(json, false);
}

export function SegmentResponseToJSONTyped(value?: SegmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segment': SegmentToJSON(value['segment']),
        'accountCount': value['accountCount'],
        'hasPermission': value['hasPermission'],
        'statsByStatusAndPeriod': ((value['statsByStatusAndPeriod'] as Array<any>).map(SegmentStatisticToJSON)),
    };
}

